export default __webpack_public_path__ + "static/media/bg3_mob_.9d676ed4.png";